import React from "react";
import { StyledForm, MUIDeviceFormControl, MUIDeviceFormLabel, paddingStyle } from "./style.module";
import { FormMandatoryIcon } from "./FormMandatoryIcon";
import { Col } from "react-bootstrap";
import { Box, Checkbox, FormControlLabel } from "@mui/material";
import { IsLoggedInUserViewer } from "../../../../hoc/withAuthRedirect";

export const FormCheckbox = ({ id, elementkey, isMandatory, label, selectList, onSelect, isDisabled, value }) => {
  const handleSelect = (e) => {
    onSelect({
      target: {
        id: e.target.id,
        value: e.target.value,
      },
    });
  };
  return (
    <StyledForm.Group as={Col} lg="4" id={id} controlId={id} style={paddingStyle} key={elementkey}>
      <MUIDeviceFormControl>
        <MUIDeviceFormLabel id={id + "-row-check-box-group-label"}>
          {isMandatory && <FormMandatoryIcon />}
          {label}
        </MUIDeviceFormLabel>
        <Box sx={{ display: "flex", flexDirection: "row", color: "#808080" }}>
          {selectList.map((item) => {
            return (
              <FormControlLabel
                key={item.value}
                value={item.value}
                control={
                  <Checkbox
                    id={id}
                    disabled={IsLoggedInUserViewer() || isDisabled || item.disableItem}
                    defaultChecked={false}
                    checked={value.includes(item.value)}
                    onChange={handleSelect}
                  />
                }
                label={<span style={{ fontSize: ".8rem" }}>{item.label}</span>}
              />
            );
          })}
        </Box>
      </MUIDeviceFormControl>
    </StyledForm.Group>
  );
};
